import get from 'lodash/get';
import { Ticket } from '../../models/tickets';
import { CheckoutState } from '../../state';

export const getConstrainedInstrumentType = (state: CheckoutState) =>
    get(state, 'tickets.constrainedInstrumentType', null);

export const getConstrainedPaymentMethods = (state: CheckoutState) =>
    get(state, 'tickets.constrainedPaymentMethods', []);

export const getFullImageUrl = (ticket: Ticket) =>
    get(ticket, 'image.original.url', '');

export const getImageThumbnailUrl = (ticket: Ticket) =>
    get(ticket, 'image.url', '');

export const getTicketsById = (state: CheckoutState) =>
    get(state, 'tickets.ticketsById', {});

export const getTicketIds = (state: CheckoutState) =>
    get(state, 'tickets.ticketIds', []);
